// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { KeyLight, KeyLightT, verifyKeyLight } from "./key-light";
import { PaginationMeta, PaginationMetaT, verifyPaginationMeta } from "./pagination-meta";

/**
 * Paginated response for key light.
 */
export class PaginatedKeysLight implements flatbuffers.IUnpackableObject<PaginatedKeysLightT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): PaginatedKeysLight {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsPaginatedKeysLight(
    bb: flatbuffers.ByteBuffer,
    obj?: PaginatedKeysLight,
  ): PaginatedKeysLight {
    return (obj || new PaginatedKeysLight()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsPaginatedKeysLight(
    bb: flatbuffers.ByteBuffer,
    obj?: PaginatedKeysLight,
  ): PaginatedKeysLight {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new PaginatedKeysLight()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  meta(obj?: PaginationMeta): PaginationMeta | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new PaginationMeta()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  data(index: number, obj?: KeyLight): KeyLight | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new KeyLight()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  dataLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startPaginatedKeysLight(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMeta(builder: flatbuffers.Builder, metaOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, metaOffset, 0);
  }

  static addData(builder: flatbuffers.Builder, dataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, dataOffset, 0);
  }

  static createDataVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDataVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endPaginatedKeysLight(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createPaginatedKeysLight(
    builder: flatbuffers.Builder,
    metaOffset: flatbuffers.Offset,
    dataOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    PaginatedKeysLight.startPaginatedKeysLight(builder);
    PaginatedKeysLight.addMeta(builder, metaOffset);
    PaginatedKeysLight.addData(builder, dataOffset);
    return PaginatedKeysLight.endPaginatedKeysLight(builder);
  }

  unpack(): PaginatedKeysLightT {
    return new PaginatedKeysLightT(
      this.meta() !== null ? this.meta()!.unpack() : null,
      this.bb!.createObjList<KeyLight, KeyLightT>(this.data.bind(this), this.dataLength()),
    );
  }

  unpackTo(_o: PaginatedKeysLightT): void {
    _o.meta = this.meta() !== null ? this.meta()!.unpack() : null;
    _o.data = this.bb!.createObjList<KeyLight, KeyLightT>(this.data.bind(this), this.dataLength());
  }

  unpackFields(...fields: string[]): PaginatedKeysLightT {
    const t = new PaginatedKeysLightT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("meta")) {
      t.meta = this.meta() !== null ? this.meta()!.unpack() : null;
    }
    if (fieldSet.has("data")) {
      t.data = this.bb!.createObjList<KeyLight, KeyLightT>(this.data.bind(this), this.dataLength());
    }
    return t;
  }
}

export class PaginatedKeysLightT implements flatbuffers.IGeneratedObject {
  constructor(
    public meta: PaginationMetaT | null = null,
    public data: KeyLightT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const meta = this.meta !== null ? this.meta!.pack(builder) : 0;
    const data = PaginatedKeysLight.createDataVector(
      builder,
      builder.createObjectOffsetList(this.data),
    );

    return PaginatedKeysLight.createPaginatedKeysLight(builder, meta, data);
  }

  clone(): PaginatedKeysLightT {
    const obj = new PaginatedKeysLightT();
    obj.meta = this.meta !== null ? this.meta!.clone() : null;
    obj.data = this.data.map((e) => e.clone());
    return obj;
  }

  equals(other: PaginatedKeysLightT): boolean {
    if (this.meta !== null && other.meta !== null) {
      if (!this.meta!.equals(other.meta!)) return false;
    } else if (this.meta !== other.meta) return false;
    if (this.data.length !== other.data.length) return false;
    for (let i = 0; i < this.data.length; i++) {
      const a = this.data[i];
      const b = other.data[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyPaginatedKeysLight(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyPaginationMeta(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyKeyLight);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
